import React from 'react';
import PropTypes from 'prop-types';
import { ProducerGames } from 'components/producer-games/producer-games';

import './provider.scss';

export const ProviderUI = ({ match: { params: { id: producer } } }) => (
  <ProducerGames coreProps={{ producer }} />
);

ProviderUI.propTypes = {
  match: PropTypes.shape().isRequired,
};

export default ProviderUI;
